function removeGroupsByIds(groups = [], ids = []) {
  return groups.reduce((acc, group = {}) => (
    ids.includes(group.id) ? acc : [...acc, group]
  ), []);
}

export default removeGroupsByIds;
